module.exports = __webpack_public_path__ + "img/coinbankB28.b1fd1b08.jpg";